/* eslint-disable arrow-body-style */
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {DealActions, SellerActions, SellerListActions} from "../deal.actions";
import {catchError, exhaustMap, map, of} from "rxjs";
import {Store} from "@ngrx/store";
import {SellerService} from "../../services/seller.service";
import {ErrorHandlingUtil} from "../../../shared/utils/error-handling-util";
import { EMPTY_SELLER } from "../../models/seller";

export const loadSellerList = createEffect(
    (actions$ = inject(Actions), sellerService = inject(SellerService)) => {
        return actions$.pipe(
            ofType(SellerListActions.load),
            exhaustMap(() =>
                sellerService.getSellers().pipe(
                    map((sellers) => SellerListActions.loadSuccess({sellers})),
                    catchError((errorResponse: any) => of(SellerListActions.loadError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)}))))
            )
        );
    },
    {functional: true}
);

export const loadSeller = createEffect(
    (actions$ = inject(Actions), sellerService = inject(SellerService)) => {
        return actions$.pipe(
            ofType(SellerActions.load),
            exhaustMap((action) => {
                const sellerId = action.sellerId;
                return sellerService.getSeller(sellerId).pipe(
                    map((seller) => SellerActions.loadSuccess({seller})),
                    catchError((errorResponse: any) => of(SellerActions.loadError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)}))));
            })
        );
    },
    {functional: true}
);

export const createSeller = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), sellerService = inject(SellerService)) => {
        return actions$.pipe(
            ofType(SellerActions.create),
            exhaustMap((action) => {
                return sellerService.saveSeller({
                        ...EMPTY_SELLER,
                        ...{
                            name: {
                                ...EMPTY_SELLER.name,
                                text: action.sellerName
                            }
                        }
                    }
                ).pipe(
                    map((seller) => SellerActions.createSuccess({seller})),
                    catchError((errorResponse: any) => of(SellerActions.createError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)}))));
            })
        );
    },
    {functional: true}
);

export const saveSellerOnDealAfterLoadingSeller = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions)) => {
        return actions$.pipe(
            ofType(SellerActions.createSuccess),
            map((action) => action.seller.id
                ? DealActions.saveSellerOnDeal({sellerId: action.seller.id})
                : SellerActions.loadError({errorMsg: ""})));
    },
    {functional: true}
);
